<template>
	<span v-if="!$slots.default" :class="activityClassObject">
		<span class="icon-list__label" v-html="$present('activityName', activity)"/>
	</span>
	<v-tooltip v-else offset="8" placement="top" trigger="hover">
		<span :class="activityClassObject">
			<span class="icon-list__label" v-html="$present('activityName', activity)"/>
		</span>
		<template slot="popover">
			<slot/>
		</template>
	</v-tooltip>
</template>
<script>
export default {
	props: {
		activity: {
			required: true,
			type: String,
		},
		hasActivity: {
			default() {
				return false;
			}
		},
	},

	computed: {
		activityClassObject() {
			return {
				icon: true,
				"icon--phone": "calls" === this.activity,
				"icon--note": "notes" === this.activity,
				"icon--todo": "todo" === this.activity && !this.hasActivity,
				"icon--todo--checked": "todo" === this.activity && this.hasActivity,
				"has-activity": this.hasActivity,
			};
		},
	}
};
</script>
